import * as React from 'react'
const SvgIcoMessagePerm = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    id='ICO_MessagePerm_N_svg__Calque_1'
    viewBox='0 0 200 200'
    {...props}
  >
    <defs>
      <style>
        {
          '.ICO_MessagePerm_N_svg__st0{display:none}.ICO_MessagePerm_N_svg__st2{fill:#333;fill-rule:evenodd}'
        }
      </style>
    </defs>
    <path d='M99.01 102.74c0 4.12-4.12 8.24-8.24 8.24h-2.75c-4.12 0-8.24-4.12-8.24-8.24V94.5h-2.75v8.24c0 5.51 5.51 11 11 11v5.51h-8.24V122h19.26v-2.75h-8.24v-5.51c5.51 0 11-5.51 11-11V94.5h-2.75v8.24z' />
    <path d='M90.75 108.24c3.04 0 5.51-2.47 5.51-5.47V83.48c0-3.02-2.45-5.47-5.51-5.47h-2.72c-3.04 0-5.51 2.47-5.51 5.47v19.29c0 3.02 2.45 5.47 5.51 5.47zM104.4 78.03c1.56-.12 3.11.4 4.27 1.43 2.27 2.02 4.32 4.52 6.58 6.58 1.5 1.31 3.9.84 4.77-.95 1.06-2.18-.64-4.6-3.03-4.43-1.59.11-2.33 1.5-3.44 2.4l-1.86-1.82c1.14-1.11 2.09-2.35 3.66-2.9 3.99-1.39 8.04 1.83 7.58 6.02-.5 4.57-5.97 6.68-9.44 3.65-2.29-2.01-4.35-4.56-6.62-6.62-1.45-1.21-3.57-.89-4.58.7-1.53 2.4.79 5.41 3.5 4.58 1.17-.36 1.91-1.54 2.8-2.32l1.86 1.86c-1.18 1.15-2.15 2.42-3.78 2.94-4.36 1.4-8.44-2.52-7.29-6.93.59-2.27 2.68-4 5.02-4.18Z' />
  </svg>
)
export default SvgIcoMessagePerm

